import {
  GET_ZOHO_ACCESS,
  GET_ZOHO_ACCESS_SUCCESS,
  GET_ZOHO_ACCESS_FAILED,
  GET_ZOHO_COUNT,
  GET_ZOHO_COUNT_SUCCESS,
  GET_ZOHO_COUNT_FAILED,
  EXPORT_ZOHO_PROCESS,
  EXPORT_ZOHO_PROCESS_SUCCESS,
  EXPORT_ZOHO_PROCESS_FAILED,
  GET_EXPORT_ZOHO_DATA,
  GET_EXPORT_ZOHO_DATA_SUCCESS,
  GET_EXPORT_ZOHO_DATA_FAILED,
  GET_LOGS_ZOHO_DATA,
  GET_LOGS_ZOHO_DATA_SUCCESS,
  GET_LOGS_ZOHO_DATA_FAILED,
  LOGOUT_ZOHO,
  LOGOUT_ZOHO_SUCCESS,
  LOGOUT_ZOHO_FALIED,
} from "./actionTypes";

const initialState = {
  zohoAccess: null,
  zohoAccessFailed: null,
  zohoCount: null,
  zohoCountFailed: null,
  zohoLoader: false,
  logsData: null,
  logsDataFailed: null,
  exportData: null,
  exportDataFailed: null,
  zohoLogoutErr:null,
  zohoLogoutSucc:null,
};

const zohoIntegrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ZOHO_ACCESS:
      state = {
        ...state,
        zohoLoader: true,
        zohoAccess: null,
        zohoAccessFailed: null,
      };
      break;
    case GET_ZOHO_ACCESS_SUCCESS:
      state = {
        ...state,
        zohoLoader: false,
        zohoAccess: action.payload,
        zohoAccessFailed: null,
      };
      break;
    case GET_ZOHO_ACCESS_FAILED:
      state = {
        ...state,
        zohoLoader: false,
        zohoAccess: null,
        zohoAccessFailed: action.payload,
      };
      break;
    case GET_ZOHO_COUNT:
      state = {
        ...state,
        zohoLoader: true,
        zohoCount: null,
        zohoCountFailed: null,
      };
      break;
    case GET_ZOHO_COUNT_SUCCESS:
      state = {
        ...state,
        zohoLoader: false,
        zohoCount: action.payload,
        zohoCountFailed: null,
      };
      break;
    case GET_ZOHO_COUNT_FAILED:
      state = {
        ...state,
        zohoLoader: false,
        zohoCount: null,
        zohoCountFailed: action.payload,
      };
      break;
    case EXPORT_ZOHO_PROCESS:
      state = {
        ...state,
        zohoLoader: true,
        exportSuccess: null,
        exportFailed: null,
      };
      break;
    case EXPORT_ZOHO_PROCESS_SUCCESS:
      state = {
        ...state,
        zohoLoader: false,
        exportSuccess: action.payload,
        exportFailed: null,
      };
      break;
    case EXPORT_ZOHO_PROCESS_FAILED:
      state = {
        ...state,
        zohoLoader: false,
        exportSuccess: null,
        exportFailed: action.payload,
      };
      break;
    case GET_EXPORT_ZOHO_DATA:
      state = {
        ...state,
        zohoLoader: true,
        exportData: null,
        exportDataFailed: null,
      };
      break;
    case GET_EXPORT_ZOHO_DATA_SUCCESS:
      state = {
        ...state,
        zohoLoader: false,
        exportData: action.payload,
        exportDataFailed: null,
      };
      break;
    case GET_EXPORT_ZOHO_DATA_FAILED:
      state = {
        ...state,
        zohoLoader: false,
        exportData: null,
        exportDataFailed: action.payload,
      };
      break;
    case GET_LOGS_ZOHO_DATA:
      state = {
        ...state,
        zohoLoader: true,
        logsData: null,
        logsDataFailed: null,
      };
      break;
    case GET_LOGS_ZOHO_DATA_SUCCESS:
      state = {
        ...state,
        zohoLoader: false,
        logsData: action.payload,
        logsDataFailed: null,
      };
      break;
    case GET_LOGS_ZOHO_DATA_FAILED:
      state = {
        ...state,
        zohoLoader: false,
        logsData: null,
        logsDataFailed: action.payload,
      };
      break;
      case LOGOUT_ZOHO:
        state = {
          ...state,
          zohoLoader: true,
          zohoLogoutSucc: null,
          zohoLogoutErr: null,
        };
        break;
      case LOGOUT_ZOHO_SUCCESS:
        state = {
          ...state,
          zohoLoader: false,
          zohoLogoutSucc: action.payload,
          zohoLogoutErr: null,
        };
        break;
      case LOGOUT_ZOHO_FALIED:
        state = {
          ...state,
          zohoLoader: false,
          zohoLogoutSucc: null,
          zohoLogoutErr: action.payload,
        };
        break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default zohoIntegrationReducer;
